import { getInitials } from "@/lib/string";
import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { AVATAR_SIZE_CLASS_MAP, INITIALS_SIZE_CLASS_MAP } from "./const";

export type DisplayAvatarProps = {
  text: string;
  size: "sm" | "md" | "lg" | "xl";
  picture?: string | null;
  className?: string;
};

export const DisplayAvatar = ({
  text,
  picture,
  size,
  className,
}: DisplayAvatarProps) => {
  return (
    <Avatar className={cn(AVATAR_SIZE_CLASS_MAP[size], className)}>
      <AvatarImage src={picture ?? undefined} />

      <AvatarFallback
        className={cn(
          INITIALS_SIZE_CLASS_MAP[size],
          "bg-foreground-2",
          className,
        )}
      >
        {getInitials(text, 2)}
      </AvatarFallback>
    </Avatar>
  );
};
